import { TableCell } from '@cbhq/cds-web/tables';
import { Tag } from '@cbhq/cds-web/tag/Tag';

type StatusCellProps = { manageUsers?: boolean };

export function StatusCell({ manageUsers }: StatusCellProps) {
  return (
    <TableCell alignItems={manageUsers ? undefined : 'flex-end'}>
      <Tag colorScheme="green">active</Tag>
    </TableCell>
  );
}
